import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import {
  Message,
  SelectItem,
  TreeNode,
  ConfirmDialogModule,
  ConfirmationService,
  MenuItem,
} from 'primeng';
import { ActivatedRoute, Router } from '@angular/router';
import { OrganisationsService } from '../../services/organisations.service';

@Component({
  selector: 'org-tree',
  templateUrl: 'org-tree.component.html',
})
export class OrgTreeComponent implements OnInit {
  //@ViewChild(UsersComponent) userDetails: UsersComponent

  @Input('orgId')
  set orgId(value: number) {
    this._orgId = value;
  }
  get orgId(): number {
    return this._orgId;
  }
  private _orgId: number;

  @Input('orgType')
  set orgType(value: number) {
    this._orgType = value;
  }
  get orgType(): number {
    return this._orgType;
  }
  private _orgType: number;

  @Output() selectedItemsChange: EventEmitter<any>;
  private _selectedItems: any;
  @Input('selectedItems')
  public set selectedItems(value: any) {
    this._selectedItems = value;
    this.selectedItemsChange.emit(value);
  }

  public get selectedItems(): any {
    return this._selectedItems;
  }

  private _selectedIds: any;
  @Input('selectedIds')
  public set selectedIds(value: any) {
    console.log(value);
    this._selectedIds = value;
    this.refreshSelection();
  }

  public get selectedIds(): any {
    return this._selectedIds;
  }

  public isLoaded: boolean = false;
  public orgnodes: any = [];

  private OrgType_VME = 1;
  private OrgType_Customer = 2;
  private OrgType_Supplier = 3;
  private OrgType_CustomerAndSupplier = 4;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private orgService: OrganisationsService,
  ) {
    this.selectedItemsChange = new EventEmitter<any>();
  }

  ngOnInit() {
    this.load();
  }

  load() {
    this.orgService.structurebyorgid(this.orgId).then((result) => {
      let selectedRootNode: any = result[0];
      this.orgnodes = result.length > 0 ? result[0].children : [];
      this.isLoaded = true;

      if (this.orgType == this.OrgType_Customer) {
        this.orgnodes = this.orgnodes.filter((x) => x.data.nodeType == 'Department');
      } else if (this.orgType == this.OrgType_Supplier) {
        this.orgnodes = this.orgnodes.filter((x) => x.data.nodeType == 'Region');
      }

      this.expandAll();
      this.refreshSelection();
    });
  }

  expandAll() {
    this.orgnodes.forEach((node) => {
      this.expandRecursive(node, true);
    });
  }

  private expandRecursive(node: TreeNode, isExpand: boolean) {
    node.expanded = isExpand;
    if (node.children) {
      node.children.forEach((childNode) => {
        this.expandRecursive(childNode, isExpand);
      });
    }
  }

  public refreshSelection() {
    const ids = this._selectedIds;
    if (ids && ids.some((x) => x.isAll)) {
      this.selectAll();
    } else {
      this.processOrgTreeNode(this.orgnodes, ids);
    }
  }

  private processOrgTreeNode(nodes: TreeNode[], ids: any[]) {
    const selected = [];

    const fillSelected = (items: TreeNode[]): TreeNode[] => {
      const res = items.filter((x) => isSelected(x));
      selected.push(...res);
      return res;
    };

    const isSelected = (item: TreeNode): boolean => {
      let res =
        (item.data.nodeType == 'Team' || item.data.nodeType == 'Depot') &&
        ids.some((x) => x.id == item.data.nodeId);
      return res || fillSelected(item.children).length > 0;
    };

    fillSelected(nodes);

    this.selectedItems = selected;
  }

  public getSelectedIds() {
    return (
      (this.selectedItems &&
        this.selectedItems
          .filter((x) => x.data.nodeType == 'Team' || x.data.nodeType == 'Depot')
          .map((x) => x.data.nodeId)) ||
      []
    );
  }

  public selectAll() {
    const selectedItems = [];
    const stack = (this.orgnodes && [...this.orgnodes]) || [];
    while (stack.length) {
      let item = stack.pop();
      selectedItems.push(item);
      item.selectable = false;
      if (item.children) {
        item.children.forEach((x) => stack.push(x));
      }
    }
    this.selectedItems = selectedItems;
  }

  public deselectAll() {
    const stack = (this.orgnodes && [...this.orgnodes]) || [];
    while (stack.length) {
      let item = stack.pop();
      item.selectable = true;
      if (item.children) {
        item.children.forEach((x) => stack.push(x));
      }
    }
    this.selectedItems = [];
  }
}
